/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 39%;
  @media (min-width: 320px) and (max-width: 480px) {
    left: 56%;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    left: 50%;
  }
  transform: translate(-50%, -50%) rotate(90deg);
`;

const LandingPageSpinner = ({inverse}) => {
  const type = inverse ? 'inverse' : 'brand';
  return (
    <Wrapper>
      <div className='slds-spinner--large'>
        <img src={'/assets/images/spinners/slds_spinner_' + type + '.gif'} alt='Loading...' />
      </div>
    </Wrapper>
  )
};

export default LandingPageSpinner;
